'use client';

import { ensureFocusVisibleStyle } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import type { SignupDownloadHandoff } from '../../services/signup-api/signup-api';

export interface StoreBadgesProps {
  handoff: SignupDownloadHandoff;
}

/**
 * The official App Store and Google Play badges, each a link to its store in
 * a new tab. The badge art is decorative; the link carries the name.
 */
const BADGE_FOCUS_STYLE_ID = 'signup-download-badge-focus-visible';

export function StoreBadges({ handoff }: StoreBadgesProps) {
  const { t } = useTranslation('signup');
  // The flow's shared keyboard focus ring, as the shell's own links use.
  ensureFocusVisibleStyle(BADGE_FOCUS_STYLE_ID, ['.signup-download__badge']);
  return (
    <div
      className="signup-download__badges"
      role="group"
      aria-label={t('download.badges.groupLabel')}
    >
      <a
        className="signup-download__badge"
        href={handoff.appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${t('download.badges.appStore')} ${t('footer.opensInNewTab')}`}
        data-analytics-action="signup.download-app-store.activate"
        data-testid="signup-download-app-store"
      >
        <img src="/brand/app-store.svg" alt="" />
      </a>
      <a
        className="signup-download__badge"
        href={handoff.playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${t('download.badges.googlePlay')} ${t('footer.opensInNewTab')}`}
        data-analytics-action="signup.download-play-store.activate"
        data-testid="signup-download-play-store"
      >
        <img src="/brand/play-store.svg" alt="" />
      </a>
    </div>
  );
}
